<div class="gutter-top-56">
  <div class="header-collapse header-sticky" #top>
    <div class="header-content">
      <div class="title-section-info">
        <h2 class="section-title mb-0">{{title}}</h2>
        <button
          type="button"
          class="btn info-tooltip"
          ngbTooltip="Quick access to items you have been working on."
          placement='right'
          [autoClose]="'outside'"
          triggers='hover'
          *ngIf="icon">
          <img class="info-icon" src="{{icon}}" alt="">
        </button>
      </div>
      <button  class="btn btn-link ey-btn-link" type="button" (click)="opened = !opened">
        {{opened ? 'Hide' : 'Show'}}
      </button>
    </div>
  </div>
  <div class="body-collapse collapse" [ngClass]="{'show': opened}">
    <ng-content></ng-content>
  </div>
</div>
